module.exports = __webpack_public_path__ + "static/media/contact.d0577cb2.svg";